export const inspectionChecklist = [
  {
    title: "Team Robot Compliance",
    description:
      "Team is only competing with ONE robot. They have no spare or replacement robots.",
    rule: "<R1>",
  },
  {
    title: "Student Work Verification",
    description:
      "Team testifies that the designing, building, and programming of the robot was done only by the students on the team.",
    rule: "<R2>",
  },
  {
    title: "License Plate Requirement",
    description:
      "Robot displays at least one (1) easily visible VEX IQ Competition license plate.",
    rule: "<R4>",
  },
  {
    title: "Size Compliance",
    description: "The Robot fits within the starting size of 11” x 19” x 15”.",
    rule: "<R5>, <R6>",
  },
  {
    title: "Official Components Usage",
    description:
      "Robot is constructed ONLY from official robot components from the VEX IQ product line.",
    rule: "<R7>, <R8>",
  },
  {
    title: "Nonfunctional Decorations",
    description:
      "Any robot decorations are nonfunctional and do not affect performance.",
    rule: "<R8>",
  },
  {
    title: "Controller Connectivity",
    description:
      "Robot installed VEX IQ Brain can communicate with the VEX IQ Controller.",
    rule: "<R9>",
  },
  {
    title: "Motor Limit",
    description: "Robot uses no more than (6) VEX IQ Smart Motors.",
    rule: "<R10>",
  },
  {
    title: "Battery Compliance",
    description:
      "Robot uses no more than (1) single VEX IQ battery pack or (6) AA batteries.",
    rule: "<R11>",
  },
  {
    title: "Firmware Up-to-Date",
    description: "VEX IQ firmware (VEXos) is up to date.",
    rule: "<R12>",
  },
  {
    title: "Parts Modification",
    description:
      "No Robot parts have been modified except for cutting metal shafts.",
    rule: "<R13>",
  },
  {
    title: "Safety and Attachment Compliance",
    description:
      "Robot does not have detachable components posing safety risks.",
    rule: "<R14>, <G10>, <G11>",
  },
];
